/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import TopbarMenuLink from "./TopbarMenuLink";
import { connect } from "react-redux";
import { logout } from "../../../actions/auth/authAction";
import DefaultUser from "../../../img/default_user.png";

import {
  Badge,
  ListGroup,
  ListGroupItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCog,
  faUsers,
  faSignOutAlt,
  faAngleDown,
  faLink,
} from "@fortawesome/free-solid-svg-icons";

class TopbarProfile extends PureComponent {
  state = {
    isOpen: false,
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  render() {
    const { auth } = this.props;

    let showPartnerLink = false;
    if (auth && auth.user && auth.user.isPartner) {
      showPartnerLink = true;
    }

    return (
      <UncontrolledDropdown
        className="user-box position-relative ml-2"
        isOpen={this.state.isOpen}
        toggle={this.toggle}
      >
        <DropdownToggle
          color="link"
          className="p-0 text-left d-flex align-items-center"
        >
          <div className="d-block p-0 avatar-icon-wrapper">
            <Badge color="success" className="badge-circle p-top-a">
              Online
            </Badge>
            <div className="avatar-icon rounded">
              <img
                src={this.props.auth.user.picture || DefaultUser}
                alt="..."
              />
            </div>
          </div>
          <div className="d-none d-xl-block pl-2">
            <div className="font-weight-bold">
              {this.props.auth.user.fullName}
            </div>
          </div>
          <span className="pl-1 pl-xl-3">
            <FontAwesomeIcon icon={faAngleDown} className="opacity-5" />
          </span>
        </DropdownToggle>
        <DropdownMenu
          right
          className="dropdown-menu-lg overflow-hidden p-0 nav-collapsed-wrapper navbar-collapse"
        >
          <div className="navbar-collapse-inner p-0">
            <ListGroup flush>
              <ListGroupItem className="p-2 m-n1">
                <TopbarMenuLink
                  title="Settings"
                  icon={faUserCog}
                  iconColor="bg-grow-early"
                  path="/settings"
                  onClick={this.toggle}
                />
              </ListGroupItem>

              <ListGroupItem className="p-2 m-n1">
                <TopbarMenuLink
                  title="Integrations"
                  icon={faLink}
                  iconColor="bg-midnight-bloom"
                  path="/integrations"
                  onClick={this.toggle}
                />
              </ListGroupItem>
              <ListGroupItem className="p-2 m-n1">
                {!showPartnerLink && (
                  <TopbarMenuLink
                    title="Become a Partner"
                    path="/partners/signup"
                    icon={faUsers}
                    iconColor="bg-malibu-beach"
                  />
                )}
                {showPartnerLink && (
                  <TopbarMenuLink
                    title="Profile"
                    icon={faUsers}
                    path={`/partners/${this.props.auth.user.partnerSlug}`}
                    iconColor="bg-malibu-beach"
                    onClick={this.toggle}
                  />
                )}
              </ListGroupItem>
              <ListGroupItem className="p-2 m-n1">
                <TopbarMenuLink
                  title="Log Out"
                  icon={faSignOutAlt}
                  path="/dashboard"
                  onClick={this.props.logout}
                  iconColor="bg-strong-bliss"
                />
              </ListGroupItem>
            </ListGroup>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.login,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    logout(dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TopbarProfile);
